import { getQueryString, getURLParameter } from '../utils/utils';
import { prosCollectionZoneConfigMap } from '../utils/prosCollectionZoneConfigMap';
import { pageTypes } from '../utils/pageTypes';

export const getAAPageType = (brand, zone) => {
  const { pageType } = prosCollectionZoneConfigMap(brand, zone);

  const aaPageTypeMap = {
    [pageTypes.itemPage]: 'product',
    [pageTypes.unavailableItemPage]: 'product',
    [pageTypes.addToCartPage]: 'product',
    [pageTypes.wishListPage]: 'wishlist',
    [pageTypes.zeroSearchResultsPage]: 'search results',
    [pageTypes.registryZeroSearchResultsPage]: 'search results',
    [pageTypes.cartPage]: 'shopping bag',
    [pageTypes.purchaseCompletePage]: 'order confirmation',
    [pageTypes.categorySplashPage]: 'splash',
    [pageTypes.homePage]: 'home page',
    [pageTypes.browsePage]: 'browse page',
    [pageTypes.orderDetailsPage]: 'order details page',
    [pageTypes.purchaseHistoryPage]: 'purchase history page',
    [pageTypes.purchaseTrackingPage]: 'order tracking page',
  };

  const aaPageType = aaPageTypeMap[pageType] || '';

  if (!aaPageType) {
    // eslint-disable-next-line no-console
    console.warn(
      'Missing page type for AA due to invalid recommendationContext',
    );
  }

  return aaPageType;
};

export const getTrackingValue = (trackingVariable, query) => {
  const querystring = getQueryString(query);
  const value = getURLParameter(trackingVariable, querystring);
  if (value !== null) return value;

  const mvValue = getURLParameter('tdp', querystring);
  if (mvValue === null) return null;

  const foundItem = mvValue.split('~x').find((subValue) => {
    const [key] = subValue.split('~z');
    return key === trackingVariable;
  });

  return foundItem ? foundItem.split('~z')[1] : null;
};

export const getCMParameter = (paramName, queryString) => getTrackingValue(`cm_${paramName}`, queryString)
  || getTrackingValue(paramName, queryString);

export const getHeaderId = (queryString, argChoiceId) => {
  const choiceId = argChoiceId || getCMParameter('choiceId', queryString);
  return choiceId?.match(/@(H.+?)@/)?.[1] || '';
};

export const getBatchId = (queryString, argChoiceId) => {
  const choiceId = argChoiceId || getCMParameter('choiceId', queryString);
  return choiceId?.match(/-([\w-]+)/)?.[1] || '';
};

export const getCGIDParameter = (queryString, argChoiceId) => {
  const choiceId = argChoiceId || getCMParameter('choiceId', queryString);
  return choiceId?.split('-')?.[0]?.substring(3, 9) || '';
};
